import React, { useState } from 'react';
import { Paperclip, Download, Send, ShieldCheck, ShieldAlert, Mic } from 'lucide-react';

const dt = (s) => (s ? new Date(s).toLocaleString('it-IT', { dateStyle: 'short', timeStyle: 'short' }) : '—');
export const day = (s) => (s ? new Date(s).toLocaleDateString('it-IT') : '—');

export function Deadlines({ r }) {
  const late = (d) => d && new Date(d) < new Date();
  const items = [['Ricevuta il', dt(r.created_at)], ['Avviso di ricevimento entro', r.acked_at ? `dato il ${day(r.acked_at)}` : day(r.ack_due), !r.acked_at && late(r.ack_due)],
    ['Riscontro entro', r.closed_at ? `dato il ${day(r.closed_at)}` : day(r.feedback_due), !r.closed_at && late(r.feedback_due)]];
  if (r.delete_after) items.push(['Cancellazione automatica', day(r.delete_after)]);
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2 text-sm" data-testid="wb-deadlines">
      {items.map(([l, v, bad]) => <div key={l} className="border border-[#1F242C] px-3 py-2"><p className="text-[10px] uppercase tracking-[0.15em] text-[#7A7F87]">{l}</p><p className={bad ? 'text-[#E37A72]' : ''}>{v}</p></div>)}
    </div>
  );
}

export function Thread({ r, me, onSend, onUpload, onDownload, testid = 'wb' }) {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const run = async (fn) => { setBusy(true); try { await fn(); } finally { setBusy(false); } };
  return (
    <div className="space-y-4">
      <div className="space-y-2" data-testid={`${testid}-messages`}>
        {r.messages.length === 0 && <p className="text-sm text-[#7A7F87]">Nessun messaggio.</p>}
        {r.messages.map((m) => (
          <div key={m.id} className={`max-w-[85%] px-4 py-3 border ${m.from === me ? 'ml-auto border-[#D4AF37]/40 bg-[#D4AF37]/5' : 'border-[#1F242C]'}`}>
            <p className="text-[10px] uppercase tracking-[0.15em] text-[#7A7F87] mb-1">{m.from === 'segnalante' ? 'Segnalante' : 'Gestore'} · {dt(m.at)}</p>
            <p className="text-sm whitespace-pre-wrap">{m.text}</p>
          </div>
        ))}
      </div>
      {onSend && <div className="flex gap-2">
        <textarea rows={2} value={text} onChange={(e) => setText(e.target.value)} placeholder="Scrivi un messaggio…" className="flex-1 bg-transparent border border-[#2A2F37] p-3 text-sm focus:outline-none focus:border-[#D4AF37]" data-testid={`${testid}-message-input`} />
        <button disabled={busy || !text.trim()} onClick={() => run(async () => { await onSend(text); setText(''); })} className="px-4 bg-[#D4AF37] text-black disabled:opacity-50" data-testid={`${testid}-message-send`}><Send size={16} /></button>
      </div>}
      <div>
        <p className="text-[11px] uppercase tracking-[0.15em] text-[#7A7F87] mb-2">Allegati</p>
        {r.files.length === 0 && <p className="text-sm text-[#7A7F87]">Nessun allegato.</p>}
        {r.files.map((f) => (
          <div key={f.id} className="flex items-center gap-3 py-2 border-t border-[#1F242C] text-sm">
            {f.kind === 'voice' ? <Mic size={14} className="text-[#D4AF37]" /> : <Paperclip size={14} className="text-[#D4AF37]" />}
            <span className="flex-1 truncate">{f.kind === 'voice' ? 'Messaggio vocale (voce alterata)' : f.name}</span>
            <span title={f.meta_removed ? 'Metadati rimossi' : 'Metadati non rimovibili per questo formato'}>{f.meta_removed ? <ShieldCheck size={14} className="text-[#5FC18F]" /> : <ShieldAlert size={14} className="text-[#E3B04B]" />}</span>
            {onDownload && <button onClick={() => onDownload(f)} className="text-[#D4AF37]" data-testid={`${testid}-file-${f.id}`}><Download size={14} /></button>}
          </div>
        ))}
        {onUpload && <label className="mt-2 inline-flex items-center gap-2 text-sm text-[#D4AF37] cursor-pointer" data-testid={`${testid}-upload`}><Paperclip size={14} />Aggiungi allegato
          <input type="file" className="hidden" onChange={(e) => e.target.files[0] && run(() => onUpload(e.target.files[0]))} data-testid={`${testid}-upload-input`} /></label>}
      </div>
    </div>
  );
}
